import server from '../../api/server';

export class ConsultTypesService {
    static async getTypes(token: string): Promise<any> {
        const headers = {
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token}`
        };

        try {
            const responseServer = await server.get(
              "/staff/consult-type",
              {headers}
            );

            if (responseServer.data.statusCode != 200) {
                console.log("ERROR");
                throw responseServer.data.message;
            }

            return responseServer.data.data;
        } catch (error: any) {
            throw new Error(error.response);
        }
    }
}
